import { wishList } from './wishlist';
import { getCart } from '../services/cart-api';

/**
 * Handles the click event on the overlay of the sidecart to close it.
 *
 * @function clickOutsideSideCartOpen
 */
const clickOutsideSideCartOpen = () => {
  const sidecart = document.querySelector('.js-mini-cart');

  // Check if the sidecart exists on the page
  if (sidecart) {
    const overlay = sidecart.querySelector('.overlaycart'); // Select the overlay inside the sidecart

    // Check if the overlay exists and add an event listener for the 'click' event
    if (overlay) {
      overlay.addEventListener('click', (event) => {
        event.preventDefault();
        sidecart.classList.remove('open')
      }); // Removes the 'open' class on click
    }
  }
};

/**
 * Initializes the redesigned side cart by removing old elements and updating item count.
 * Listens for cart toggle events to refresh cart data dynamically.
 * Ensures wishlist functionality is initialized when the cart opens.
 */
const initSideCartRedesign = async () => {
  document.addEventListener('pdm-cart-toggle', event => {
    const isCartOpenTriggered = event.detail.isCartOpen;

    if (isCartOpenTriggered) {
      const itemCount = document.querySelector('.mini-cart-content .mini-cart-heading__items-count');
      if (itemCount) {
        setTimeout(async () => {
          wishList(); // Initialize the wishlist functionality
    
          const cartObject = await getCart();
          if (cartObject.status) {
            itemCount.textContent = `(${cartObject.response.item_count})`;
          } 
        }, 1000);
      }
    }    
  });
}

/**
 * Initializes the event listener for the sidecart closing behavior.
 *
 * @function initializeSideCartListener
 */
const initializeSideCartListener = () => {
  clickOutsideSideCartOpen(); // Call the function to set up the sidecart listener
  initSideCartRedesign();
};

export default initializeSideCartListener;
